import { Locale, getDomains } from './host';

import type { Request } from 'express';

export const defaultMarket = Locale.De;

function stripPort(url: string | undefined): string | undefined {
  if (!url) return undefined;
  if (url.indexOf(':') === -1) {
    return url;
  }
  return url.replace(/:\d+$/, '');
}

export const getMarket = (host: string | undefined) => {
  const hostname = stripPort(host);
  return getDomains().find(({ domain }) => domain === hostname)?.locale || defaultMarket;
};

export const getMarketFromRequest = (req: Request): string => {
  const hostname = stripPort(req.headers.host);
  return getDomains().find(({ domain }) => domain === hostname)?.locale || defaultMarket;
};

export const getMarketFromLocale = (input: unknown) => {
  return Object.values(Locale).find((locale) => locale === input) || defaultMarket;
};

export const getLocaleForWidget = (market?: string) => {
  // locale for zipcode validation, etc
  return [Locale.De, Locale.At].find((locale) => locale === market) || defaultMarket;
};
